import React, { ChangeEvent } from "react";
import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import OwLabel from "../../OwLabel/OwLabel";
import SocketService from "../../../../services/SocketService";
import IOrder from "../../../../models/IOrder";

type Props = {
    order: IOrder;
};

export const StripeForm = (props: Props) => {
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (e: ChangeEvent<any>) => {
        e.preventDefault();
        e.stopPropagation();

        if (!stripe || !elements) {
            return null;
        }

        const apiUrl = SocketService.getApiEndpointURl();

        const { error } = await stripe.confirmSetup({
            elements,
            confirmParams: {
                return_url: `${apiUrl}/stripe-supplier-vendor-setup-intent-complete`,
            },
        });
    };

    return (
        <div className={"StripeForm"}>
            <form onSubmit={handleSubmit}>
                <PaymentElement />
                <button className={"mt-3 btn btn-primary"} disabled={!stripe}>
                    <OwLabel title={"submit"} />
                </button>
            </form>
        </div>
    );
};
